import { useState, useContext, useEffect, useRef } from "react"
import { BtnLoader, CSelect, toast, CInputText, CInputPassword, CToggle, CModal } from "../../components/widget"
import { ContextNav, ContextDashboard, ContextLoading } from "../../context";
import { DatePicker } from "jalali-react-datepicker";
import { EditCompanyApi, CompanyApi, BusinessScopesApi, JobPositionsApi } from "../../api";
import { useNavigate } from "react-router-dom";
import Cropper from "react-cropper";
import { convertDateToString } from "../../utils";

export const Company = () => {
    const navigate = useNavigate()
    const formRef: any = useRef()
    const startDateRef: any = useRef()
    const endDateRef: any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxDash = useContext(ContextDashboard)
    const CtxLoad = useContext(ContextLoading)
    const [defualtDate, setDefualtDate] = useState<any>(null);
    const [listBusiness, setListBusiness] = useState<any>([])
    const [listPosition, setListPosition] = useState<any>([])
    const [detailData, setDetailData] = useState<any>()
    const [visibleImageModal, setVisibleImageModal] = useState<boolean>(false)
    const [isSelecetNewImage, setisSelecetNewImage] = useState<boolean>(false)
    const [image, setImage] = useState();
    const [cropData, setCropData] = useState<any>(null);
    const [cropper, setCropper] = useState<any>();

    const onChangeValueDate = (e: any, type: string) => {
        let data = { ...defualtDate };
        data[type] = convertDateToString(e.value._i.slice(0, 10));
        data[`${type}_date`] = e.value._i.slice(0, 10);
        setDefualtDate(data)
    }

    const getCropData = () => {
        if (typeof cropper !== "undefined") {
            setCropData(cropper.getCroppedCanvas().toDataURL());
            setVisibleImageModal(false)
            setisSelecetNewImage(true)
            console.log(cropper.getCroppedCanvas().toDataURL());

        }
    };

    const selectImage = (e: any) => {
        e.preventDefault();
        let files;
        if (e.dataTransfer) {
            files = e.dataTransfer.files;
        } else if (e.target) {
            files = e.target.files;
        }
        const reader = new FileReader();
        reader.onload = () => {
            setImage(reader.result as any);
        };
        reader.readAsDataURL(files[0]);
        setVisibleImageModal(true)
    }

    const onFinishAdd = async (e: any) => {
        e.preventDefault()        
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await EditCompanyApi(formRef, defualtDate,detailData ,isSelecetNewImage , cropData)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast("تغییرات با موفقیت ثبت گردید", { type: "success" })
        }
        else {
            toast(res.message, { type: "error" })
        }
    }

    const getDetail = async () => {
        let res = await CompanyApi()
        if (res.success) {
            formRef.current['name'].value = res.data.name;
            formRef.current['phone'].value = +res.data.phone;
            formRef.current['activity'].value = +res.data.business_scope_id;
            formRef.current['status'].checked = res.data?.user?.status == 1 ? true : false;
            formRef.current['nameBoss'].value = res.data?.user?.profile?.fname;
            formRef.current['familyBoss'].value = res.data?.user?.profile?.lname;
            formRef.current['gender'].value = res.data?.user?.profile?.gender;
            formRef.current['age'].value = res.data?.user?.profile?.age;
            formRef.current['mobile'].value = res.data?.user?.profile?.mobile;
            formRef.current['job'].value = res.data?.user?.profile?.job_position_id;
            setDefualtDate({
                'start': convertDateToString(res?.data?.establishment_date.slice(0, 10)),
                'start_date': res?.data?.establishment_date.slice(0, 10),
            })
            if (res.data.logo != null && res.data.logo != "") { setCropData(res.data.logo) }
            setDetailData(res.data)
        }
    }

    const getBussines = async () => {
        let res = await BusinessScopesApi()
        if (res.success) {
            setListBusiness(res.data)
        }
    }

    const getPosition = async () => {
        let res = await JobPositionsApi()
        if (res.success) {
            setListPosition(res.data)
        }
    }


    useEffect(() => {
        document.title = "اطلاعات شرکت | دایان"
        CtxNav.setActiveMenuItem({ 'item': 4, 'subItem': 0, })
        getDetail();
        getBussines()
        getPosition()
    }, [])

    return (
        <>
            <form ref={formRef} onSubmit={onFinishAdd} className="w-full flex flex-col">
                <div className=" w-full flex flex-col">
                    <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">اطلاعات شرکت</h1>
                    <div className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:py-[30px] sm:px-[20px] px-[10px]">

                        <div className=" md:w-10/12 w-full flex flex-col md:flex-row items-center border-b pb-[15px] sm:pb-[30px]">
                            <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                                <svg x="0px" y="0px" viewBox={'0 0 485 485'} className={`  h-5 'fill-dayan-gray-100' `}>
                                    <use xlinkHref="/assetes/svg/upload.svg#upload" />
                                </svg>
                                <span className="text-[11px] mr-3">لوگو سازمان</span>
                            </div>
                            <div className=" w-full md:w-10/12 flex flex-col sm:flex-row items-center">
                                <label className="w-[130px] h-[130px] bg-dayan-gray-50 rounded-full shadow flex justify-center items-center cursor-pointer">
                                    {cropData == null ?
                                        <>
                                            <div className="w-[120px] h-[120px] border border-dashed border-[#afacac] rounded-full flex justify-center items-center flex-col text-xs">
                                                <svg x="0px" y="0px" viewBox={'0 0 218.166 218.166'} className={`  h-7 mb-2 fill-dayan-gray-80 `}>
                                                    <use xlinkHref="/assetes/svg/photo.svg#photo" />
                                                </svg>
                                                <span>انتخاب لوگو</span>
                                            </div>
                                        </>
                                        :
                                        <div className="w-[120px] h-[120px] border border-dashed border-[#afacac] rounded-full flex justify-center items-center flex-col text-xs">
                                            <img src={cropData} className="w-full h-full rounded-full" />
                                        </div>
                                    }
                                    <input onChange={(e: any) => selectImage(e)} type={'file'} className="hidden" />
                                </label>
                            </div>
                        </div>

                        <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                            <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                                <svg x="0px" y="0px" viewBox={'0 0 460 460'} className={`  h-5 'fill-dayan-gray-100' `}>
                                    <use xlinkHref="/assetes/svg/report.svg#report" />
                                </svg>
                                <span className="text-[11px] mr-3"> مشخصات حساب </span>
                            </div>
                            <div className=" w-full md:w-10/12  flex items-center">
                                <div className=" w-[50%] h-[50px] pl-1 sm:pl-2">
                                    <CInputText name="name" title="نام سازمان" type="text" required={true} />
                                </div>
                                <div className=" w-[50%] h-[50px] pr1 sm:pr-2">
                                    <CInputPassword name="password" title="رمز عبور" />
                                </div>
                            </div>
                        </div>

                        <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                            <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                                <svg x="0px" y="0px" viewBox={'0 0 279 279'} className={`  h-5 'fill-dayan-gray-100' `}>
                                    <use xlinkHref="/assetes/svg/bag.svg#bag" />
                                </svg>
                                <span className="text-[11px] mr-3">اطلاعات شرکت</span>
                            </div>
                            <div className=" w-full md:w-10/12  flex items-center">
                                <div className=" w-[50%] h-[50px] pl-1 sm:pl-2">
                                    <CInputText name="phone" title="تلفن ثابت" type="number" required={true} />
                                </div>
                                <div className=" w-[50%] h-[50px] pr1 sm:pr-2">
                                    <div className={` flex relative px-[7px] h-full rounded-[5px] items-center mb-[3px] border border-dayan-gray-100`}>
                                        <span className="text-[12px] text-dayan-gray-100 absolute bg-white top-[-12px] right-[15px] px-[10px]">تاریخ تاسیس شرکت</span>
                                        <div className={` jalali-datePicker flex items-center justify-center w-full h-full bg-transparent px-[10px] sm:text-[13px] text-[11px]`} >
                                            {defualtDate != null &&
                                                <DatePicker ref={startDateRef} timePicker={false} onClickSubmitButton={(e: any) => { onChangeValueDate(e, 'start') }} value={defualtDate.start} />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                            <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                                <svg x="0px" y="0px" viewBox={'0 0 431.667 431.667'} className={`  h-5 'fill-dayan-gray-100' `}>
                                    <use xlinkHref="/assetes/svg/apartment.svg#apartment" />
                                </svg>
                                <span className="text-[11px] mr-3"> حوزه فعالیت </span>
                            </div>
                            <div className=" w-full md:w-10/12  flex items-center">
                                <div className=" w-[50%] h-[50px] pl-1 sm:pl-2">
                                    <CSelect name="activity" placeholder={'انتخاب'} title=" حوزه فعالیت " border={true} required={true}>
                                        {listBusiness?.map((item: any, index: number) =>
                                            <option key={index} value={item.id}>{item.name}</option>
                                        )}
                                    </CSelect>
                                </div>
                                <div className=" w-[50%] h-full pr-1 flex items-center">
                                    <span className="text-sm mx-2">فعال</span>
                                    <div className="flex flex-col justify-center items-center">
                                        <span className="text-[10px]  mb-2 text-center ">وضعیت شرکت</span>
                                        <CToggle name="status" defaultChecked={true} />
                                    </div>
                                    <span className="text-sm mx-2">غیر فعال</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className=" w-full flex flex-col mt-[30px]">
                    <h1 className="sm:text-2xl text-lg font-bold mb-[15px]">اطلاعات رابط شرکت</h1>
                    <div className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:py-[30px] sm:px-[20px] px-[10px]">

                        <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                            <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                                <svg x="0px" y="0px" viewBox={'0 0 512 512'} className={`  h-5 'fill-dayan-gray-100' `}>
                                    <use xlinkHref="/assetes/svg/person.svg#person" />
                                </svg>
                                <span className="text-[11px] mr-3">اطلاعات رابط شرکت</span>
                            </div>
                            <div className=" w-full md:w-10/12  flex flex-col sm:flex-row items-center">
                                <div className=" w-full sm:w-[50%] h-[50px] flex  items-center pl-0 sm:pl-2">
                                    <div className=" w-[50%] h-full pl-1">
                                        <CInputText name="nameBoss" title="نام " type="text" required={true} />
                                    </div>
                                    <div className=" w-[50%] h-full pr-1">
                                        <CInputText name="familyBoss" title="نام خانوادگی " type="text" required={true} />
                                    </div>
                                </div>
                                <div className=" w-full sm:w-[50%] h-[50px] flex mt-6 sm:mt-0 items-center pl-0 sm:pl-2">
                                    <div className=" w-[50%] h-full pl-1">
                                        <CSelect name="gender" placeholder={'جنست'} title="جنست" border={true} required={true}>
                                            <option value={1}>مرد</option>
                                            <option value={2}>زن</option>
                                        </CSelect>
                                    </div>
                                    <div className=" w-[50%] h-full pr-1">
                                        <CInputText name="age" title="سن" type="number" required={true} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                            <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                            </div>
                            <div className=" w-full md:w-10/12  flex items-center">
                                <div className=" w-[50%] h-[50px] pl-1 sm:pl-2">
                                    <CSelect name="job" placeholder={'انتخاب'} title="سمت شغلی" border={true} required={true}>
                                        {listPosition?.map((item: any, index: number) =>
                                            <option key={index} value={item.id}>{item.name}</option>
                                        )}
                                    </CSelect>
                                </div>
                                <div className=" w-[50%] h-[50px] pl-1 sm:pl-2">
                                    <CInputText name="mobile" title="موبایل" type="number" required={true} />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className=" w-full flex flex-col my-[20px]">
                    <div className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:px-[20px] px-[10px]">
                        <div className=" w-full  flex items-center">
                            {CtxLoad.displayLoadingBtn ?
                                <button type="button" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow cursor-not-allowed relative flex justify-center items-center"><BtnLoader /></button>
                                :
                                <button type="submit" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow">ثبت</button>
                            }
                        </div>
                    </div>
                </div>

            </form>

            <CModal visible={visibleImageModal} setVisible={setVisibleImageModal} radius={'10px'} uId={'Mo-add-profile'} >
                <div className=" w-full flex flex-col">
                    <Cropper
                        style={{ height: 300, width: "100%", borderRadius: "30px" }}
                        zoomTo={0.5}
                        initialAspectRatio={1}
                        preview=".img-preview"
                        src={image}
                        viewMode={1}
                        minCropBoxHeight={10}
                        minCropBoxWidth={10}
                        background={false}
                        responsive={true}
                        autoCropArea={1}
                        checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                        onInitialized={(instance) => {
                            setCropper(instance);
                        }}
                        guides={true}
                    />
                    <div className=" w-full mt-[20px] flex justify-center items-center">

                        <button type={'button'} onClick={getCropData} className=" w-[80px] mx-2 h-10 bg-dayan-orange-50  flex items-center justify-center rounded-[5px] text-white relative ">
                            <span>برش</span>
                        </button>
                        <button type={'button'} onClick={() => { setVisibleImageModal(false) }} className=" w-[80px] mx-2 h-10 bg-dayan-gray-200  flex items-center justify-center rounded-[5px] text-white">
                            <span>لغو</span>
                        </button>

                    </div>
                </div>
            </CModal>
        </>
    )
}
